import React, { useState } from 'react';

export default function ButtonEmailHover (props) {

  const [hoverLinkButton, setHoverLinkButton] = useState({
    padding: '20px 40px',
    margin: '20px',
    border: '1px solid #fff',
    borderRadius: '4px',
    textTransform: 'uppercase',
    fontWeight: '700',
    textAlign: 'center',
    background: '#80a3db',
    color: '#fff',
    textDecoration: 'none',
    cursor: 'pointer',
  });

  return(
      <div style={{
          height: '50px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}>
        <div
          onClick={() =>
            window.location.href = `mailto:${props.email}?subject=${encodeURIComponent(props.subject)}&body=${encodeURIComponent(props.emailBody)}`
          }
          style={hoverLinkButton}
          onMouseEnter={() => setHoverLinkButton({
            padding: '20px 40px',
            margin: '20px',
            border: '1px solid #fff',
            borderRadius: '4px',
            textTransform: 'uppercase',
            fontWeight: '700',
            textAlign: 'center',
            background: '#fff',
            color: '#80a3db',
            textDecoration: 'none',
            cursor: 'pointer',
          })}
          onMouseLeave={() => setHoverLinkButton({
            padding: '20px 40px',
            margin: '20px',
            border: '1px solid #fff',
            borderRadius: '4px',
            textTransform: 'uppercase',
            fontWeight: '700',
            textAlign: 'center',
            background: '#80a3db',
            color: '#fff',
            textDecoration: 'none',
            cursor: 'pointer',
          })}
          >
          {props.buttonName}
        </div>
    </div>
  )
}
